import { render, staticRenderFns } from "./DocumentVideoDocument.vue?vue&type=template&id=5d72a7a2&scoped=true"
import script from "./DocumentVideoDocument.vue?vue&type=script&lang=js"
export * from "./DocumentVideoDocument.vue?vue&type=script&lang=js"
import style0 from "./DocumentVideoDocument.vue?vue&type=style&index=0&id=5d72a7a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d72a7a2",
  null
  
)

export default component.exports